var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}}),_c('v-card-text',[_vm._v(" Logging in... ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }